<template>
  <div class="mt-4 mb-4">
    <span class="ingredient-title">Velg kassepunkt</span>
    <select v-model="selectedTerminal" @change="setSelectedTerminal()" class="form-select">
      <option v-for="terminal in this.terminals" :key="terminal.id" :value="terminal">
        <span v-if="terminal.terminalId == 'ALL'">
            ALLE TILSAMMEN
        </span>
        <span v-else-if="terminal.terminalId == 'POS_AND_KIOSK' && useFunctionality() == 'ALL'">
            ALLE KASSENE OG KIOSKENE
        </span>
        <span v-else-if="terminal.terminalId == 'POS_AND_KIOSK'">
            ALLE KIOSKENE
        </span>
        <span v-else-if="terminal.terminalId == 'WEBSHOP'">
            NETTBUTIKKEN
        </span>
        <span v-else>
            {{ terminal.terminalType }} - {{ terminal.deviceName }}
        </span>
      </option>
    </select>
  </div>
</template>

<script>
  import MerchantUtil from "@/util/MerchantUtil";

  export default {
    props: {
      terminals: Array,
      terminal:Object
    },
    data() {
      return {
        selectedTerminal: {}
      };
    },
    mounted() {
      if(this.terminal){
        this.selectedTerminal = this.terminal;
      }
    },
    watch: {
      // Keep the dropdown in sync when the parent resets the selected terminal — e.g. after switching
      // location, which rebuilds the terminal list without re-mounting this component. Without this the
      // internal selection stays stale (the previous location's terminal object, with the wrong
      // locationId), so "Vis X-rapport"/"Ta oppgjør" run against the wrong location — the webshop Z-report
      // then fails/settles the wrong location.
      terminal(newTerminal) {
        this.selectedTerminal = newTerminal;
      }
    },
    methods: {
      useFunctionality(){
        return MerchantUtil.useFunctionality();
      },
      setSelectedTerminal(){
        this.$emit('setSelectedTerminal', this.selectedTerminal);
      }
    }
  }
</script>

<style scoped>
  .ingredient-title{
    display: block;
    overflow: auto;
    font-weight: bold;
    margin:15px 0 10px 0;
  }
</style>
